import useGetDealer from "~/components/Forms/DealerPassportForm2/hook/useGetDealer";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import {
  getDealerDopBir,
  getDealerDopFields,
  getDealerFields,
} from "~/components/Forms/DealerPassportForm2/Base/options";
import useUpdateDealer from "~/components/Forms/DealerPassportForm2/hook/useUpdateDealer";
import {
  defaultFormValue,
  toForm,
  toServer,
} from "~/components/Forms/DealerPassportForm2/Base/lib/config/adapter";
import { NOTIFICATIONS } from "~/constans/notifications";
import { useTranslation } from "react-i18next";
import Base from "./index";
import React, { useEffect, useRef, useState, useMemo } from "react";
import Preloader from "~/components/Preloader";
import { useQueryClient } from "react-query";

export const BaseHoc = (props) => {
  const { DealerId } = props;
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const dealerFields = getDealerFields(t);

  const dealerFieldsDop = getDealerDopFields(t);
  const dealerDopBir = getDealerDopBir(t);
  const { mutate: updateDealer, isLoading: isUpdating } = useUpdateDealer();
  const { data: dataDealer, isFetching: isLoadingDealer } =
    useGetDealer(DealerId);
  const [addNotificationMutation] = useAddNotificationMutation({});

  const currentHeadCompany = useMemo(() => {
    return dataDealer?.headCompany
      ? {
          value: String(dataDealer.headCompany.id),
          label: dataDealer.headCompany.dealerName,
        }
      : null;
  }, [dataDealer?.headCompany]);

  const onSubmit = (data: any) => {
    const apiData = toServer(data, dataDealer);

    updateDealer(
      { dealerId: DealerId, data: apiData },
      {
        onSuccess: (updatedDealer) => {
          queryClient.setQueryData(
            ["dealer", { dealerId: DealerId }],
            updatedDealer
          );

          addNotificationMutation({
            variables: {
              type: NOTIFICATIONS.success,
              content: t("common.сhange_was_successful"),
            },
          });
        },
        onError: (error) => {
          console.error("Ошибка при сохранении:", error);
        },
      }
    );
  };

  const loaderResolver = useRef(null);
  const [dumbLoader, setDumbLoader] = useState(true);
  const [defaultValue, setDefaultValue] = useState(defaultFormValue);

  useEffect(() => {
    if (dataDealer) {
      setDefaultValue(toForm(dataDealer, currentHeadCompany));
    }
  }, [dataDealer, currentHeadCompany]);

  useEffect(() => {
    if (isLoadingDealer) {
      loaderResolver.current = () => setDumbLoader(false);
    } else {
      loaderResolver.current && loaderResolver.current();
    }
  }, [isLoadingDealer]);

  if (isLoadingDealer || dumbLoader) {
    return <Preloader />;
  }

  return (
    <Base
      {...props}
      dealerFields={dealerFields}
      dealerFieldsDop={dealerFieldsDop}
      dealerDopBir={dealerDopBir}
      onSubmit={onSubmit}
      dataDealer={dataDealer}
      defaultValue={defaultValue}
    />
  );
};
